import * as api from '@gitbook/api-client';
import { Icon, type SVGIconComponent } from '@gitbook/spine-icons';
import { assertNever } from '@gitbook/util-ts';

export function ContentKitIcon(props: {
    icon: api.ContentKitIcon;
    size?: number;
    className?: string;
}) {
    const { icon, className } = props;
    const IconComponent = getContentKitIconComponent(icon);
    return <IconComponent className={className} size={props.size} />;
}

export function getContentKitIconComponent(icon: api.ContentKitIcon): SVGIconComponent {
    switch (icon) {
        case api.ContentKitIcon.Close:
            return Icon.X;
        case api.ContentKitIcon.Edit:
            return Icon.Edit;
        case api.ContentKitIcon.Github:
            return Icon.GitHub;
        case api.ContentKitIcon.Maximize:
            return Icon.Maximize;
        case api.ContentKitIcon.Email:
            return Icon.Email;
        case api.ContentKitIcon.Settings:
            return Icon.Settings;
        case api.ContentKitIcon.Search:
            return Icon.Search;
        case api.ContentKitIcon.Delete:
            return Icon.Trashcan;
        case api.ContentKitIcon.Star:
            return Icon.Star;
        case api.ContentKitIcon.Warning:
            return Icon.Warning;
        case api.ContentKitIcon.Link:
            return Icon.Link;
        case api.ContentKitIcon.LinkExternal:
            return Icon.ExternalLink;
        case api.ContentKitIcon.Eye:
            return Icon.Eye;
        case api.ContentKitIcon.EyeOff:
            return Icon.EyeOff;
        case api.ContentKitIcon.Gitlab:
            return Icon.GitLab;
        case api.ContentKitIcon.Lock:
            return Icon.Lock;
        case api.ContentKitIcon.Check:
            return Icon.Check;
        case api.ContentKitIcon.CheckCircle:
            return Icon.CheckCircle;
        default:
            assertNever(icon);
    }
}
